module.exports = __webpack_public_path__ + "img/email.aa618a49.svg";